import { render, staticRenderFns } from "./Carouseltem.vue?vue&type=template&id=668ca565&scoped=true"
import script from "./Carouseltem.vue?vue&type=script&lang=js"
export * from "./Carouseltem.vue?vue&type=script&lang=js"
import style0 from "./Carouseltem.vue?vue&type=style&index=0&id=668ca565&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668ca565",
  null
  
)

export default component.exports